// extracted by mini-css-extract-plugin
export default {"Fold":"Fold_Fold__sstQl","FullHeight":"Fold_FullHeight__HRxFu","OverlayDark":"Fold_OverlayDark__3g-VF","FoldMain":"Fold_FoldMain__jnV5t"};